import { createTheme } from "@mui/material/styles";

/**
 * Единая дизайн-система приложения «Питомник Миф и реальность».
 * Все компоненты используют эту палитру и типографику.
 */
export const appTheme = createTheme({
    palette: {
        primary: {
            main: "#28282a",
            light: "#3d3d40",
            dark: "#1a1a1c",
            contrastText: "#fff",
        },
        secondary: {
            main: "#ff3366",
            light: "#ff5c85",
            dark: "#e62b5a",
            contrastText: "#fff",
        },
        background: {
            default: "#ffffff",
            paper: "#fff5f8",
        },
        text: {
            primary: "#28282a",
            secondary: "#5c5c5e",
        },
        divider: "rgba(40, 40, 42, 0.08)",
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
            letterSpacing: "0.02em",
        },
        h2: {
            fontWeight: 700,
            fontSize: "1.75rem",
            letterSpacing: "0.02em",
        },
        h3: {
            fontWeight: 600,
            fontSize: "1.5rem",
        },
        h4: {
            fontWeight: 600,
            fontSize: "1.25rem",
        },
        h5: {
            fontWeight: 600,
            fontSize: "1.125rem",
        },
        h6: {
            fontWeight: 600,
            fontSize: "1rem",
        },
        body1: {
            fontSize: "1rem",
            lineHeight: 1.5,
        },
        body2: {
            fontSize: "0.875rem",
            lineHeight: 1.5,
        },
        caption: {
            fontSize: "0.75rem",
            lineHeight: 1.4,
        },
    },
    shape: {
        borderRadius: 12,
    },
    spacing: 8,
    transitions: {
        duration: {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195,
        },
        easing: {
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            easeOut: "cubic-bezier(0, 0, 0.2, 1)",
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        },
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    transition: "color 0.2s ease, opacity 0.2s ease",
                    "&:hover": {
                        opacity: 0.85,
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    transition: "background-color 0.2s ease, color 0.2s ease, transform 0.2s ease",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 12,
                },
            },
        },
    },
});

export const sectionTitleSx = {
    fontWeight: 700,
    fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" },
    textTransform: "uppercase" as const,
    letterSpacing: "0.02em",
    color: "text.primary",
    textAlign: "center" as const,
};

export const sectionAccentLineSx = {
    height: "4px",
    width: "55px",
    display: "block",
    margin: "10px auto 0",
    backgroundColor: "secondary.main",
};
